/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import angularCorePackage from '@angular/core/package.json';
import angularMaterialPackage from '@angular/material/package.json';
import fabricComponentsPackage from '@fabric/components/package.json';

const libraryPackages = [angularCorePackage, angularMaterialPackage, fabricComponentsPackage];

export const environment = {
  production: true,
  appName: 'CAE AI/ML Engine',
  appVersion: '~~{packageVersion}~~',
  appVersionCodename: 'robe',
  buildNumber: '~~{Build.BuildNumber}~~',
  environmentName: '@@{environmentName}@@',
  libraries: libraryPackages.map((pkg) => ({ name: pkg.name, version: pkg.version })),
  apiMap: {},
  appLauncherUrls: {},
  featureToggleMap: {},
  auth: {
    issuer: 'https://login.microsoftonline.com/@@{tenantId}@@/v2.0',
    clientId: '@@{clientId}@@',
    redirectUri: window.location.origin,
    responseType: 'code',
    scope: 'openid profile email offline_access @@{clientId}@@/.default',
    // turn off validation that discovery document endpoints start with the issuer url defined above
    strictDiscoveryDocumentValidation: false,
    preserveRequestedRoute: true,
  },
  backendApiUrl: '@@{backendUrl}@@'
};
